// 연속 처치(폭주, COMBAT-FEEL 2.5): 처치 사슬 타이머와 5마리마다의 환급·이동 속도 효과. 영웅 시간 영역에서 매 틱 진행한다.
import { Ev } from "../shared/events";
import { RAMPAGE, STYLE_RANK, rampageMpRefund } from "../shared/config";
import type { GameSim } from "./game";

export class RampageState {
  chain = 0; timer = 0; buff = 0; tiers = 0; best = 0;
  /** 스타일 랭크 0..STYLE_RANK.letters.length(0 = 없음). 사슬에서만 계산하고 사슬이 끊기면 0 */
  rank = 0;
}

/** 사슬 수 → 스타일 랭크(0 = 없음) */
export function styleRankOf(chain: number): number {
  let r = 0;
  for (let i = 0; i < STYLE_RANK.thresholds.length; i++) if (chain >= STYLE_RANK.thresholds[i]) r = i + 1;
  return r;
}

export class Rampage {
  constructor(private readonly g: GameSim) {}

  reset(): void {
    const r = this.g.rampage;
    r.chain = 0; r.timer = 0; r.buff = 0; r.tiers = 0; r.best = 0; r.rank = 0;
  }

  /** 달리기 속도 배율(효과가 남아 있으면 1 + speedBonus) */
  speedMult(): number { return this.g.rampage.buff > 0 ? 1 + RAMPAGE.speedBonus : 1; }

  /** 영웅 틱마다: 사슬 창과 속도 효과를 줄인다 */
  step(): void {
    const r = this.g.rampage;
    if (r.buff > 0) r.buff--;
    if (r.timer > 0 && --r.timer === 0) { r.chain = 0; r.rank = 0; }
  }

  /** 영웅의 처치 한 마리(환경 처치는 부르지 않는다). 창을 다시 채우고 5의 배수면 단계 보상 */
  onKill(x: number, z: number): void {
    const g = this.g, r = g.rampage, h = g.hero;
    r.chain++; r.timer = RAMPAGE.window; r.best = Math.max(r.best, r.chain);
    const left = RAMPAGE.every - (r.chain % RAMPAGE.every);
    const chain = g.emit(Ev.KillChain);
    chain.x = x; chain.z = z; chain.a = r.chain; chain.b = RAMPAGE.window; chain.c = left === RAMPAGE.every ? 0 : left;
    const rank = styleRankOf(r.chain);
    if (rank > r.rank) {
      r.rank = rank;
      const up = g.emit(Ev.StyleRank);
      up.x = h.x; up.z = h.z; up.a = rank; up.b = r.chain;
    }
    if (r.chain % RAMPAGE.every !== 0) return;
    r.tiers++;
    const mp = Math.min(h.maxMp - h.mp, h.maxMp * rampageMpRefund(g.regionKey));
    h.mp += mp;
    for (let i = 0; i < h.cooldowns.length; i++) h.cooldowns[i] = Math.max(0, h.cooldowns[i] - RAMPAGE.cooldownRefund);
    r.buff = Math.max(r.buff, RAMPAGE.buffTicks);
    const e = g.emit(Ev.Rampage);
    e.x = h.x; e.z = h.z; e.a = r.chain; e.b = r.tiers; e.c = mp; e.d = RAMPAGE.buffTicks;
  }
}
